<template>
	<div class="headerBar">
		<div class="startBar tbl">
			<div class="tblrow">
				<div class="tblcell">
					<img class="logo" src="@/assets/hp_logo_v2.svg" width="40px" @click.stop="jump('/')"/>
				</div>
				<div class="menuCell tblcell" style="text-align:right">
					<span class="menu" @click.stop="jump('/recruit/')">採用情報</span><span class="menu" @click.stop="jump('/contact/')">お問い合わせ</span><a v-scroll-to="'#siteMap'"><span class="menu">サイトマップ</span></a>
					<div class="menuBtn"><span class="menu_icon" @click.stop="menuOpen"></span></div>
				</div>
			</div>
		</div>
		<div class="scrollBar_area">
			<div class="scrollBar tbl">
				<div class="tblrow">
					<div class="tblcell">
						<img class="logo" src="@/assets/hp_logo.svg" width="120px" @click.stop="jump('/')"/>
					</div>
					<div class="menuCell tblcell" style="text-align:right">
						<span class="menu" @click.stop="jump('/recruit/')">採用情報</span><span class="menu" @click.stop="jump('/contact/')">お問い合わせ</span><a v-scroll-to="'#siteMap'"><span class="menu">サイトマップ</span></a>
						<div class="menuBtn"><span class="menu_icon" @click.stop="menuOpen"></span></div>
					</div>
				</div>
			</div>
		</div>
		<div class="menu_Window">
			<div class="spacer"></div>
			<ul>
				<li @click.stop="jump2('/company/')">会社情報</li>
				<li @click.stop="jump2('/services/')">事業内容</li>
				<li @click.stop="jump2('/recruit/')">採用情報</li>
				<li @click.stop="jump2('/contact/')">お問い合わせ</li>
				<li @click.stop="jump2('/privacy/')">プライバシーポリシー</li>
				<li @click.stop="jump2('#siteMap')">サイトマップ</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			fixedHeader: false
		}
	},
	mounted() {
		this.$nextTick(function(){
			let helpb = document.querySelectorAll(".menu_Window");
			let body = false;
			for (let i = 0; i < helpb.length; i++) {
				if (helpb[i].parentNode.tagName == "BODY") {
					body = true;
					break;
				}
			}
			if (!body) {
				let help = document.querySelector(".menu_Window");
				document.body.appendChild(help);
			} else {
				let helpb = document.querySelectorAll(".menu_Window");
				for (let i = 0; i < helpb.length; i++) {
					if (helpb[i].parentNode.tagName != "BODY") {
						helpb[i].parentNode.removeChild(helpb[i]);
					}
				}
			}
			
			window.addEventListener('scroll', this.scrollIn);
		});
	},
	destroyed() {
		window.removeEventListener('scroll', this.scrollIn);
	},
	methods: {
		scrollIn() {
			let s = document.documentElement.scrollTop || document.body.scrollTop;
			let w = window.innerHeight;
			let me = document.querySelector(".scrollBar_area");
			let stb = document.querySelector(".startBar");
			let scb = document.querySelector(".scrollBar");
			let sp = document.querySelector(".spacer");
			
			if (s > 200) {
				if (!this.fixedHeader) {
					this.fixedHeader = true;
					me.classList.add("scrollIn");
					stb.classList.add("scrollIn");
					scb.classList.add("scrollIn");
					sp.classList.add("scrollIn");
				}
			} else {
				if (this.fixedHeader) {
					this.fixedHeader = false;
					me.classList.remove("scrollIn");
					stb.classList.remove("scrollIn");
					scb.classList.remove("scrollIn");
					sp.classList.remove("scrollIn");
				}
			}
		},
		jump(path) {
			this.$router.push(path);
		},
		jump2(path) {
			this.menuOpen();
			this.jump(path);
		},
		menuOpen() {
			let btn = document.querySelectorAll(".menu_icon");
			let help = document.querySelector(".menu_Window");
			
			if (!btn[0].classList.contains("close")) {
				for (let i = 0; i < btn.length; i++) {
					btn[i].classList.add("close");
				}
				help.classList.add("open");
			} else {
				for (let i = 0; i < btn.length; i++) {
					btn[i].classList.remove("close");
				}
				help.classList.remove("open");
			}
		}
	}
}
</script>

<style lang="less" scoped>
.headerBar {
	position: relative;
	padding: 10px 40px;
	background-color: #eb5f1a;
	color: #fff;
	box-shadow: 0px 3px 3px 1px rgba(0,0,0,0.2);
	z-index: 9999;
	
	.startBar {
		width: 100%;
		transition: all 1s;
		visibility: visible;
	}
	
	.scrollBar_area {
		position: absolute;
		width: calc(100% - 80px);
		padding: 6px 40px;
		margin-left: -40px;
		background-color: #eb5f1a;
		z-index: -100;
		box-shadow: 0px 3px 3px 1px rgba(0,0,0,0.2);
		top: -100px;
		transition: all 0.1s;
	}
	
	.scrollBar {
		width: 100%;
		z-index: 9999;
	}
	
	.startBar.scrollIn {
		visibility: hidden;
	}
	
	.scrollBar_area.scrollIn {
		position: fixed;
		top: 0;
		transition: all 1s;
		z-index: 9999;
	}
	
	.logo {
		cursor: pointer;
		margin-top: 3px;
	}
	
	.menuCell {
		
	}
	
	.menuBtn {
		display: none;
	}
	
	.menu {
		padding: 0 20px;
		border-left: 1px solid rgba(255,255,255,0.5);
		text-align: center;
		cursor: pointer;
	}
}

@media(max-width:420px) {
	.headerBar {
		padding: 10px 10px 10px 20px;
		
		.scrollBar_area {
			width: calc(100% - 30px);
			padding: 6px 10px 6px 20px;
			margin-left: -20px;
		}
		
		.menuCell {
			width: 40px;
			vertical-align: middle;
		}
		
		.menuBtn {
			position: relative;
			display: block;
			width: 40px;
			height: 40px;
			margin: 0;
			cursor: pointer;
			
			.menu_icon {
				display: block;
				position: absolute;
				top: 50%;
				left: 50%;
				width: 24px;
				height: 4px;
				margin: -2px 0 0 -12px;
				background: #fff;
				transition: .2s;
				
				&::before, &::after {
					display: block;
					content: "";
					position: absolute;
					top: 50%;
					left: 0;
					width: 24px;
					height: 4px;
					background: #fff;
					transition: .3s;
				}
				
				&::before {
					margin-top: -10px;
				}
				
				&::after {
					margin-top: 6px;
				}
			}
		}
		
		.menuBtn .close {
			background: transparent;
			
			&::before, &::after {
				margin-top: 0;
			}
			
			&::before {
				transform: rotate(-45deg);
			}
			
			&::after {
				transform: rotate(-135deg);
			}
		}
		
		.menu {
			display: none;
		}
	}
}
</style>
